module.exports = new __parcel__URL__("step-one.dcc386c3.svg").toString();